import { Alert, alertClasses, alpha, Badge, Box, Button, IconButton, styled } from "@mui/material";

import { BorderRadiusVariants } from "fond/theme";
import { withDefaultProps } from "fond/utils/withDefaultProps";
import { BlockSpinner as Spinner } from "fond/widgets";

import { LegendItemType } from "./Legend";

export const Row = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isVisible",
})<{ isVisible: boolean }>(({ theme, isVisible }) => {
  return {
    alignItems: "center",
    display: "flex",
    flexGrow: 1,
    fontSize: theme.typography.size.small,
    color: isVisible ? "inherit" : theme.palette.action.disabled,
    width: "100%",

    "&.rct-tree-item-title-GROUP": {
      color: isVisible ? theme.palette.biarri.primary.red : theme.palette.action.disabled,
      fontWeight: 700,
      fontSize: 13,
    },
  };
});

export const StyledAlert = styled(Alert)({
  [`& .${alertClasses.message}`]: {
    width: "100%",
  },
});

export const CloseButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
  "& > svg": {
    fontSize: theme.typography.size.large,
  },
}));

export const Label = styled(Box, {
  shouldForwardProp: (prop) => prop !== "entityType" && prop !== "isVisible",
})<{ entityType: LegendItemType["Type"]; isVisible: boolean }>(({ theme, entityType, isVisible }) => ({
  fontFamily: theme.typography.fontFamily,
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
  flexGrow: 1,
  width: "100%",
}));

export const Total = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.size.small,
  whiteSpace: "nowrap",
}));

export const VisibilityIcon = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "isVisible",
})<{ isVisible: boolean }>(({ theme, isVisible }) => ({
  color: isVisible ? theme.palette.primary.main : theme.palette.action.disabled,
  height: 16,
  paddingInline: theme.spacing(1),
  marginLeft: theme.spacing(0.5),
  "&&&": {
    background: "none",
  },
  "& svg": {
    fontSize: theme.typography.size.medium,
  },
})).withComponent("a");

const SpinnerWithDefaults = withDefaultProps(Spinner, {
  spinnerProps: { size: 16, color: "inherit" },
  containerProps: { style: { minHeight: 16, height: 16, width: 16 }, width: "24px !important" },
});
export const BlockSpinner = styled(SpinnerWithDefaults)(({ theme }) => ({}));

export const LegendButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "isActive",
})<{ isActive?: boolean }>(({ theme, isActive }) => ({
  borderRadius: BorderRadiusVariants.small,
  paddingTop: 0,
  paddingBottom: 0,
  minWidth: 0,
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
  ...(isActive && {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, 0.16),
    },
  }),
}));

export const LegendBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge:not(.MuiBadge-invisible)": {
    fontSize: 10,
    fontWeight: "100",
    borderRadius: 3,
    padding: "0 4px",
    height: 12,
    transform: "scale(1) translate(75%, -50%)",
    background: theme.palette.secondary.main,
  },
}));
